import { apiClient, Amenity } from "rp-components"

export interface AmenityService {
    listBookableAmenities(propertyId: number): Promise<Amenity[]>
    getAmenity(propertyId: number, amenityId: string): Promise<Amenity>
}

class AmenityServiceImpl implements AmenityService {
    static instance?: AmenityService = undefined

    private constructor() {}

    static getInstance(): AmenityService {
        if (AmenityServiceImpl.instance == undefined) {
            AmenityServiceImpl.instance = new AmenityServiceImpl()
        }
        return AmenityServiceImpl.instance
    }

    async listBookableAmenities(propertyId: number): Promise<Amenity[]> {
        return apiClient.get<Amenity[]>(`properties/${propertyId}/amenityList`)
    }

    async getAmenity(propertyId: number, amenityId: string): Promise<Amenity> {
        return apiClient.get<Amenity>(`properties/${propertyId}/amenities/${amenityId}`)
    }
}

export default AmenityServiceImpl.getInstance()
